<template>
  <div class="backcolor" style="height: 100vh">
    <v-toolbar dense class="elevation-1">
      <v-icon color="pink" class="text-h4">mdi-school</v-icon>
      <v-toolbar-title
        :style="
          $vuetify.breakpoint.smAndUp
            ? 'letter-spacing: 0.5rem'
            : 'letter-spacing: 0.2rem'
        "
        class="ml-3 font-weight-bold"
        >{{ $t('school.school_aula') }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-dialog
        persistent
        max-width="600px"
        :fullscreen="$vuetify.breakpoint.mobile"
      >
        <template v-slot:activator="{ on }">
          <v-btn color="darkpink" rounded dark v-on="on" @click="MenuTurmas()">
            <v-icon left> mdi-account-group </v-icon>
            {{ $t('school.school_turmas') }}
          </v-btn>
        </template>
      </v-dialog>
    </v-toolbar>  
    <v-row class="pa-8">
      <v-col cols="12" md="6" lg="4" v-for="course in courses" :key="course.id">
        <v-card
          class="rounded-lg pointer"
          @click="getClassByCourses(course.id)"
          elevation="5"
        >
          <v-row no-gutters>
            <v-col cols="12" sm="6" lg="5">
              <v-img
                :src="course.thumbnail"
                height="200"
                :class="
                  $vuetify.breakpoint.smAndUp ? 'rounded-l-lg' : 'rounded-t-lg'
                "
              ></v-img>
            </v-col>
            <v-col cols="12" sm="6" lg="7">
              <v-row
                class="darkblue--text"
                :class="$vuetify.breakpoint.xsOnly ? 'px-4 py-2' : 'pa-4'"
              >
                <v-col cols="12">
                  <div
                    class="font-weight-bold"
                    :style="
                      $vuetify.breakpoint.xsOnly
                        ? 'font-size: 1rem'
                        : 'font-size: 1.2rem'
                    "
                  >
                    {{ course.name }}
                  </div>
                  <div>
                    <span v-if="course.qtd_classes !== 0">
                      {{ course.qtd_classes }} {{ $t('teams.team_tab.tab2') }}
                    </span>
                    <span
                      v-if="course.qtd_classes !== 0 && course.qtd_files !== 0"
                    >
                      {{ $t('certificado.cert_conteudo.conteudo6') }}
                    </span>
                    <span
                      v-if="course.qtd_files !== 0"
                      v-text="
                        course.qtd_files === 1
                          ? `${course.qtd_files} ${$t('homework.homework_arquivo.arquivo1')}`
                          : `${course.qtd_files} ${$t('homework.homework_arquivo.arquivo2')}`
                      "
                    />
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="classesList"
      :width="$vuetify.breakpoint.mdAndUp ? '65%' : '90%'"
    >
      <v-card class="rounded-lg">
        <!-- <v-card-title class="white--text darkblue">
          <div class="text-subtitle-2 mt-2">
            <span
              class="text-h6 text-md-h5 font-weight-medium text-uppercase"
              style="line-height: 0"
            >
              AULAS
            </span>
          </div>
    
          <v-spacer />
          <v-btn icon dark @click="classesList = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title> -->

        <v-tabs v-model="classTab" background-color="darkblue" grow dark>
          <v-tabs-slider></v-tabs-slider>
          <v-tab v-if="classes.length !== 0" href="#1"> Aulas </v-tab>
          <v-tab v-if="files.length !== 0" href="#2"> Arquivos </v-tab>
        </v-tabs>
        <v-tabs-items :value="classTab">
          <v-tab-item value="1">
            <v-card-text class="my-4">
              <v-row no-gutters>
                <v-col
                  cols="12"
                  md="6"
                  v-for="(data, index) in classes"
                  :key="data.id"
                >
                  <v-alert
                    class="mx-2 pointer elevation-4 d-flex align-center"
                    :color="colorLookLight(index)"
                    text
                    outlined
                    :icon="
                      $vuetify.breakpoint.xsOnly
                        ? false
                        : 'mdi-book-open-page-variant'
                    "
                    :prominent="!$vuetify.breakpoint.xsOnly"
                    @click="seeClassDetails(data)"
                    min-height="100"
                  >
                    <v-row align="center" no-gutters>
                      <v-col
                        cols="12"
                        class="grow font-weight-bold black--text"
                      >
                        <div style="font-size: 1.1rem">
                          {{ data.Class.title }}
                        </div>
                        <div style="font-size: 0.8rem">
                          {{ data.Class.project }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-alert>
                </v-col>
              </v-row>
            </v-card-text>
          </v-tab-item>
          <v-tab-item value="2">
            <v-card-text class="my-4">
              <v-row no-gutters>
                <v-col
                  cols="12"
                  sm="6"
                  v-for="(file, index) in files"
                  :key="file.id"
                >
                  <v-card
                    :href="file.uri"
                    target="_blank"
                    class="ma-2 flat white--text elevation-4"
                    height="100"
                  >
                    <v-alert
                      :icon="
                        $vuetify.breakpoint.xsOnly ? false : 'mdi-download'
                      "
                      :prominent="!$vuetify.breakpoint.xsOnly"
                      height="100%"
                      class="d-flex align-center font-weight-medium"
                      style="font-size: 1.2rem"
                      :color="colorLookLight(index)"
                      text
                      outlined
                    >
                      <span class="black--text font-weight-bold"
                        >{{ file.description }}
                      </span>
                    </v-alert>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="classDetailsDialog"
      :max-width="$vuetify.breakpoint.smAndUp ? '60%' : '95%'"
    >
      <v-card>
        <v-tabs v-model="tab" background-color="darkblue" grow dark>
          <v-tabs-slider></v-tabs-slider>
          <v-tab v-for="(n, i) in items" :key="i" :href="`#${n.id}`">
            <span> {{ n.title }} </span>
          </v-tab>
        </v-tabs>
        <v-tabs-items :value="tab">
          <v-tab-item value="1">
            <v-card class="px-4 py-6 py-sm-8 py-md-10 py-lg-16 d-flex flex-row">
              <div class="text-center">
                <v-avatar
                  :size="$vuetify.breakpoint.mdAndUp ? 260 : 200"
                  tile
                  class="rounded-xl mx-auto"
                >
                  <v-img :src="detailsData.tumbnail" />
                </v-avatar>
              </div>

              <div style="font-size: 1.2rem" class="mt-4 ml-4">
                <div style="font-size: 1.6rem" class="font-weight-black">
                  {{ detailsData.title }}
                </div>

                <div class="mt-4">
                  <strong>{{ $t('homework.homework_detalhes.detalhes1') }}</strong> {{ detailsData.project }}
                </div>
                <div><strong>{{ $t('homework.homework_detalhes.detalhes2') }}</strong> {{ detailsData.Kit.name }}</div>
                <div>
                  <strong>{{ $t('homework.homework_detalhes.detalhes3') }}</strong> {{ detailsData.description }}
                </div>
              </div>
            </v-card>
          </v-tab-item>
          <v-tab-item value="2">
            <v-card class="pt-6 px-16 backcolor mx-auto" flat>
              <v-carousel
                v-model="videos"
                hide-delimiters
                :continuous="false"
                show-arrows-on-hover
                :width="$vuetify.breakpoint.xsOnly ? 320 : ''"
                align="center"
                height="380"
              >
                <v-carousel-item v-for="pres in presentation" :key="pres.id">
                  <vimeo-player
                    ref="player"
                    :video-url="`https://player.vimeo.com/video/${pres.uri}?h=${pres.hash_parameter}`"
                  />
                </v-carousel-item>
              </v-carousel>
            </v-card>
          </v-tab-item>
          <v-tab-item value="3">
            <v-card class="pa-4">
              <v-carousel
                hide-delimiters
                show-arrows-on-hover
                :continuous="false"
                v-model="m_corousel"
              >
                <v-carousel-item
                  v-for="mount in mountFile"
                  :key="mount.id"
                  :src="mount.uri"
                  contain
                ></v-carousel-item>
              </v-carousel>
            </v-card>
          </v-tab-item>
          <v-tab-item value="4">
            <div class="text-h6 black--text mt-4 mx-6 font-weight-bold">
              {{ $t('homework.homework_detalhes.detalhes4') }}
            </div>
            <div v-for="(item, index) in exerc" :key="item.id" class="ma-4">
              <v-card class="rounded-lg pa-4" flat>
                <v-card-text class="px-2">
                  <div
                    class="text-subtitle-1 black--text font-weight-medium mb-2"
                  >
                    {{ index + 1 }}. {{ item.content }}
                  </div>
                  <div v-if="item.image != null">
                    <v-img
                      :src="item.image"
                      max-width="350px"
                      class="mx-auto mb-2"
                    />
                  </div>
                  <div
                    class="text-body-1"
                    :class="opt.correct ? 'green--text' : ''"
                    v-for="(opt, index) in item.option"
                    :key="opt.id"
                  >
                    <div v-if="item.type == 'M'">
                      {{ index + 1 }}- {{ opt.content }}
                      <v-icon v-if="opt.correct" small color="green"
                        >mdi-check</v-icon
                      >
                    </div>
                    <div v-if="item.type == 'I'">
                      {{ index + 1 }}.
                      <v-img
                        contain
                        :src="opt.content"
                        max-width="280px"
                        :class="opt.correct ? 'correctImg' : ''"
                        class="mb-2"
                      />
                    </div>
                    <div v-if="item.type == 'B'">
                      <span v-if="opt.correct" class="font-weight-bold">
                        R: {{ opt.content }}</span
                      >
                    </div>
                    <div v-if="item.type == 'D'">
                      <span v-if="opt.correct" class="font-weight-bold">
                        R: {{ opt.content }}</span
                      >
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const url = process.env.VUE_APP_API_URL;
const token = "Baerer " + localStorage.getItem("accessToken");

export default {
  data() {
    return {
      dialogRegister: false,
      rules: {
        email: (v) => !!(v || "").match(/@/) || this.$t('regras.regra_email'),
        length: (len) => (v) =>
          (v || "").length >= len ||
          `${this.$t('regras.regra_senhaMini.senha1')} ${len} ${this.$t('regras.regra_senhaMini.senha2')}`,
        required: (v) => !!v || this.$t('regras.regra_obrigatorio'),
        option: (v) => !!v || this.$t('regras.regra_opcao'),
        image: (v) => !!v || this.$t('regras.regra_image'),
        question: (v) => !!v || this.$t('regras.regra_question'),
        date: (v) => !!v || this.$t('regras.regra_data'),
        none: true,
      },
      videos: 0,
      d_carousel: false,
      m_corousel: 0,
      mounting: [],
      classes: [],
      description: null,
      noDataClass: this.$t('homework.homework_kit'),
      summary: null,
      classId: null,
      courses: [],
      classColors: [
        { light: "pink ", dark: "darkpink" },
        { light: "cyan", dark: "darkcyan" },
        { light: "yellow", dark: "darkyellow" },
      ],
      headers: [
        { text: this.$t('homework.homework_title'), value: "Class.title" },
        { text: "", value: "details", sortable: false, align: "end" },
      ],
      dialogSummarie: false,
      dialogExercises: false,
      summ: null,
      isSelecting: false,
      selectedFile: null,
      exerc: null,
      allExerc: null,
      classesList: false,
      mountFile: [],
      presentationFile: null,
      presentation: [],
      noSummaries: false,
      noExercises: false,
      classDetailsDialog: false,
      tab: null,
      classTab: null,
      items: [],
      hasPresentation: false,
      hasMounting: false,
      hasExercise: false,
      detailsData: { Kit: {} },
      videoID: null,
      files: {},
    };
  },

  created() {
    this.getCoursesSchool();
  },
  methods: {
    handleFileImport() {
      this.isSelecting = true;

      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    async onFileChanged(e) {
      let selected = e.target.files[0];
      let formData = new FormData();
      formData.append("file", selected, selected.name);
      let res = await axios.post(`${url}/lessonsExtras/files`, formData);
      this.summ = res.data.url;
      let data = { classId: this.classId, uri: this.summ };
      axios.post(`${url}/summaries`, data, {
        headers: {
          authorization: token,
        },
      });
    },
    MenuTurmas() {
      this.$parent.$parent.$parent.page = this.$t('admin.admin_menu.menu13')
    },
    colorLookLight(index) {
      let position = (index + 1) % 3;
      let color = this.classColors[position].light;
      return color;
    },
    colorLookDark(index) {
      let position = (index + 1) % 3;
      let color = this.classColors[position].dark;
      return color;
    },

    getClassByCourses(courseId) {
      axios
        .get(`${url}/courseAssembly/classesByCourses/${courseId}`, {
          headers: {
            authorization: token,
          },
        })
        .then((res) => {
          this.getCourseFiles(courseId);
          this.classTab = 1;
          this.videos = 0;
          this.classes = res.data;
          this.classesList = true;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async getCourseFiles(id) {
      try {
        let res = await axios.get(`${url}/filesCourses/byCourse/${id}`, {
          headers: {
            authorization: token,
          },
        });
        this.files = res.data;
      } catch (error) {
        console.error(error);
      }
    },
    getCoursesSchool() {
      axios
        .get(`${url}/coursesForSchool`, {
          headers: {
            authorization: token,
          },
        })
        .then((res) => {
          this.courses = res.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    async getMounting(id) {
      let m = await axios.get(`${url}/lessonsMountings/byClass/${id}`, {
        headers: {
          authorization: token,
        },
      });
      if (m.data.length !== 0) {
        this.m_corousel = 0;
        this.mountFile = m.data;
        this.hasMounting = true;
      }

      let present = await axios.get(
        `${url}/lessonsPresentations/byClass/${id}`
      );

      if (present.data.length !== 0) {
        this.presentation = present.data;
        console.log("Videos", this.presentation);
        this.hasPresentation = true;
      } else {
        this.hasPresentation = false;
      }
    },

    async seeExercises(id) {
      let res = await axios.get(`${url}/exercisesByClass?lessons=${id}`, {
        headers: {
          authorization: token,
        },
      });

      if (res.data.length != 0) {
        this.hasExercise = true;
        this.exerc = res.data;
      } else {
        this.hasExercise = false;
        this.exerc = [];
      }
    },
    toEdit(res) {
      let id = res[0].classId;
      this.$parent.$parent.$parent.exerciseId = id;
      this.$emit("message", this.$t('homework.homework_tab.tab6'));
      this.$parent.$parent.$parent.page = this.$t('homework.homework_tab.tab6');
    },
    cleanDatas() {
      this.videos = 0;
      this.items = [];
      this.hasExercise = false;
      this.hasMounting = false;
      this.hasPresentation = false;
      this.detailsData = { Kit: {} };
    },
    async seeClassDetails(data) {
      this.cleanDatas();

      await this.getMounting(data.Class.id);
      await this.seeExercises(data.Class.id);

      this.verifyTab();

      this.detailsData = data.Class;

      this.classDetailsDialog = true;
    },
    verifyTab() {
      this.items.push({
        id: 1,
        title: this.$t('homework.homework_tab.tab3'),
      });

      if (this.hasPresentation) {
        this.items.push({
          id: 2,
          title: this.$t('homework.homework_tab.tab4'),
        });
      }
      if (this.hasMounting) {
        this.items.push({
          id: 3,
          title: this.$t('homework.homework_tab.tab5'),
        });
      }
      if (this.hasExercise) {
        this.items.push({
          id: 4,
          title: this.$t('homework.homework_tab.tab6'),
        });
      }
    },
  },
};
</script>

<style scoped>
.correctImg {
  border: 5px solid #468c00;
}

.pointer {
  cursor: pointer;
}
</style>
